import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from '../../admin/AdminDashboard';
import Adminmenu from '../../admin/adminmenu/AdminMenu';
import Header from '../../Header';
import './DonorLayout.css'
import DonorDashboard from '../../donor/DonorDashboard';
import Donormenu from '../../donor/donormenu/DonorMenu';
import UrgentNeeds from '../../donor/UrgentNeeds';
import DonorNeeds from '../../donor/DonorNeeds';
import DonorNeedsView from '../../donor/DonorNeedsView';
import DonorFundManager from '../../donor/DonorFundManager'
import { DonorDonations } from '../../donor/DonorDonation';
import { DonorDocuments } from '../../donor/DonorDocuments';
import { DonorFeedback } from '../../donor/DonorFeedback';
import NewDonation from '../../donor/NewDonation';
import DonorChat from '../../donor/DonorChat';
import { DonorAddFeedback } from '../../donor/DonorAddFeedback';
import { DFundmanagerReports } from '../../donor/DFundmanagerReports';
import { DOrganisationReports } from '../../donor/DOrganizationReports';
import DFundPrintTranscript from '../../donor/DFundPrintTranscript'
import DonorProfile from '../../donor/DonorProfile'
import { RestPass } from '../../resetpassword/ResetPassword';
import DOrgPrintTranscript from '../../donor/DOrgPrintTranscript';
import {Footer} from '../../footer';
import {MobileDonationlist} from '../../mobile/MobileDonationlist';
import MobdonorDash from '../../mobile/MobdonorDash';
import MobDash from '../../mobile/MobDash';
import Mobprofile from '../../mobile/Mobprofile';

interface DonorLayoutProps {

  children?: ReactNode;
  // Define children as a ReactNode
}
const DonorLayout: React.FC<DonorLayoutProps> = ({ children }) => {
  console.log("DonorLayout ",DonorLayout)
  return (
    <div className="admin-layout-container">
      <Header />
      <div className="row">
        <Donormenu />
        <div >
          <Routes>
            <Route path="/ddashboard" element={<DonorDashboard />} />
            <Route path="/urgentneeds" element={<UrgentNeeds />} />
            <Route path="/dneeds" element={<DonorNeeds />} />
            <Route path="/needsview/:Id" element={<DonorNeedsView />} />
            <Route path="/donation/:Id/:orgID/:needtypeid" element={<DonorFundManager />} />
            <Route path="/donations" element={<DonorDonations />} />
            <Route path="/documents" element={<DonorDocuments />} />
            <Route path="/feedback" element={<DonorFeedback />} />
            <Route path="/newdonations" element={<NewDonation />} />
            <Route path="/chat/:donationID" element={<DonorChat />} />
            <Route path="/addfeedback" element={<DonorAddFeedback />} />
            <Route path="/fundreports" element={<DFundmanagerReports />} />
            <Route path="/orgreports" element={<DOrganisationReports />} />
            <Route path="/printtranscript/:fundid/:rid/*" element={<DFundPrintTranscript />} />
            <Route path="/dprofile" element={<DonorProfile />} />
            <Route path="/reset" element={<RestPass />} />
            <Route path="/orgprinttranscript/:fundid/:rid/*" element={<DOrgPrintTranscript />} />
            <Route path="/mobdonationlist/:uid/:usertype" element={<MobileDonationlist/>} />
            <Route path="/mobdashboard/:uid/:usertype" element={<MobDash/>} />
            <Route path="/mobprofile/:uid/:usertype/*" element={<Mobprofile />} />
          </Routes>
        </div>
      </div>
      { children }
      <Footer />
    </div>
  );
};

export default DonorLayout;
